import React from "react"

export const Subjects = ({
  handleRandomSubjectClick,
  handleSubjectClick,
  pageNumber,
  selectedSubjectId,
  setPageNumber,
  subjects,
}) => {
  if(subjects.length > 0) {
    return (
      <section>
        <h2>Subjects</h2>
        <div className="subject-thumbs">
          {subjects[pageNumber - 1].map((subject, index) => {
            return (
              <button
                className={`subject ${
                  subject.id === selectedSubjectId && "selected-highlight"
                }`}
                key={`subject-${index}`}
                onClick={() => handleSubjectClick(subject)}
              >
                {subject.data.characters}
              </button>
            )
          })}
        </div>
        <div className="paging">
          <button
            disabled={pageNumber === 1}
            onClick={() => setPageNumber(pageNumber - 1)}
          >
            {"<"}
          </button>
          <button
            disabled={pageNumber + 1 > subjects.length}
            onClick={() => setPageNumber(pageNumber + 1)}
          >
            {">"}
          </button>
        </div>
        <button onClick={handleRandomSubjectClick}>
          Give me a random subject
        </button>
      </section>
    )
  } else {
    return (
      <p>There are no assignments for these filters</p>
    )
  }
}
